import { TuiButtonModule } from '@taiga-ui/core';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { TableFiltersState } from './table-filters.types';

@Component({
  selector: 'wo-table-filters',
  templateUrl: './table-filters.component.html',
  styleUrls: [ './table-filters.component.scss' ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ TuiButtonModule ],
})
export class TableFiltersComponent {
  @Input() public state: TableFiltersState | null = null;
  @Output() public readonly restore = new EventEmitter<void>();
  @Output() public readonly apply = new EventEmitter<void>();
}
